import React, { Component } from 'react';
import Close from '@material-ui/icons/Close';
import { Event } from '../Tracking/Track';
import view from '../../../Enums';

class KnowMoreModal2 extends Component {
  state = {
    head: this.props.head,
    fullContent: this.props.fullContent,
    imgSrc: this.props.imgSrc
  };

  gs = this.props.getStyle;
  gc = this.props.getContent;
  gi = this.props.getImage;

  modalContent = {
    channel_management: {
      head: this.gc('channel_management'),
      fullContent: this.gc('landing_modal_content1'),
      imgSrc: this.gi('channel')
    },
    revenue_management: {
      head: this.gc('revenue_management'),
      fullContent: this.gc('landing_modal_content2'),
      imgSrc: this.gi('revenue_management')
    },
    technology: {
      head: this.gc('technology'),
      fullContent: this.gc('landing_modal_content3'),
      imgSrc: this.gi('technology')
    },
    guest_experience: {
      head: this.gc('guest_experience'),
      fullContent: this.gc('landing_modal_content4'),
      imgSrc: this.gi('guest_experience')
    }
  };

  changeContent = key => {
    this.setState({
      head: this.modalContent[key].head,
      fullContent: this.modalContent[key].fullContent,
      imgSrc: this.modalContent[key].imgSrc
    });
  };

  render() {
    return (
      <div style={this.gs('parentKnowMore')}>
        {this.props.viewMode == view.DESKTOP && (
          <div style={this.gs('parentKnowMoreHeading')}>
            <div
              onClick={evt => {
                this.changeContent('channel_management');
                Event(
                  'Partner Page',
                  'Learned more - Channel Management',
                  '',
                  ''
                );
              }}
            >
              <div
                style={
                  this.state.head == this.gc('channel_management')
                    ? this.gs('headingStylesSelected')
                    : this.gs('headingStyles')
                }
              >
                {this.gc('channel_management')}
              </div>
              {this.state.head == this.gc('channel_management') && (
                <div style={this.gs('parentKnowMoreHeadingSelected')}></div>
              )}
            </div>
            <div
              onClick={evt => {
                this.changeContent('revenue_management');
                Event(
                  'Partner Page',
                  'Learned more - Revenue Management',
                  '',
                  ''
                );
              }}
            >
              <div
                style={
                  this.state.head == this.gc('revenue_management')
                    ? this.gs('headingStylesSelected')
                    : this.gs('headingStyles')
                }
              >
                {this.gc('revenue_management')}
              </div>
              {this.state.head == this.gc('revenue_management') && (
                <div style={this.gs('parentKnowMoreHeadingSelected')}></div>
              )}
            </div>
            <div
              onClick={evt => {
                this.changeContent('technology');
                Event('Partner Page', 'Learned more - Technology', '', '');
              }}
            >
              <div
                style={
                  this.state.head == this.gc('technology')
                    ? this.gs('headingStylesSelected')
                    : this.gs('headingStyles')
                }
              >
                {this.gc('technology')}
              </div>
              {this.state.head == this.gc('technology') && (
                <div style={this.gs('parentKnowMoreHeadingSelected')}></div>
              )}
            </div>
            <div
              onClick={evt => {
                this.changeContent('guest_experience');
                Event(
                  'Partner Page',
                  'Learned more - Guest Experience',
                  '',
                  ''
                );
              }}
            >
              <div
                style={
                  this.state.head == this.gc('guest_experience')
                    ? this.gs('headingStylesSelected')
                    : this.gs('headingStyles')
                }
              >
                {this.gc('guest_experience')}
              </div>
              {this.state.head == this.gc('guest_experience') && (
                <div style={this.gs('parentKnowMoreHeadingSelected')}></div>
              )}
            </div>
          </div>
        )}
        <div style={this.gs('subKnowMore')}>
          <img style={this.gs('imgKnowMore')} src={this.state.imgSrc} />

          <Close
            className={'hover'}
            onClick={this.props.onClose}
            style={{ position: 'absolute', top: '24px', right: '24px' }}
          />

          <div style={this.gs('headKnowMore')}>{this.state.head}</div>
          <div style={this.gs('contentKnowMore')}>{this.state.fullContent}</div>
        </div>
      </div>
    );
  }
}

export default KnowMoreModal2;
